import "./shop.css";
import tea from "../assets/image/tea-hel.jpg";
import { FaHeart, FaShoppingCart } from "react-icons/fa";

export default function Shop() {
  return (
    <>
      <div className="container">
        {/* محصولات */}
        <h5 className="py-3 fs-18" style={{ borderBottom: "3px dashed rgb(10, 10, 68)" }}>
          محصولات
        </h5>
        <h6 className="py-3 fw-bold">سوغات اصفهان</h6>
        {/* <div id="products" class="d-flex flex-wrap justify-content-center justify-content-md-start"> */}
        <div className="row m-0">
          {[...Array(5)].map(() => {
            return (
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="product border border-success round pt-4 mx-1 my-2">
                  <div className="text-center">
                    <img src={tea} width="140px" height="140px" alt="not found" />
                  </div>
                  <h5 className="product-title size3 px-3 pb-3 mt-2">گز پسته ای</h5>
                  <h6 className="product-price color-red digits px-3 pb-1 ms-3 fw-bold">50000 تومان</h6>
                  <div className="d-flex justify-content-center justify-content-sm-start ms-3 px-3 mb-4">
                    <span style={{ cursor: "pointer" }}>
                      <FaHeart className="color-red"></FaHeart>
                    </span>
                    <span style={{ cursor: "pointer" }} className="mx-3">
                      <FaShoppingCart className="color-red" />
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
          {/* چای */}
          <h6 className=" py-3 mt-4 fw-bold">چای </h6>
          {/* <div id="tea" class="d-flex flex-wrap  justify-content-center justify-content-md-start"> */}
          <div className="row m-0">
            {[...Array(5)].map(() => {
              return (
                <div className="col-lg-3 col-md-4 col-sm-6">
                  <div className="product border border-success round pt-4 mx-1 my-2">
                    <div className="text-center">
                      <img src={tea} width="140px" height="140px" alt="not found" />
                    </div>
                    <h5 className="product-title size3 px-3 pb-3 mt-2">گز پسته ای</h5>
                    <h6 className="product-price color-red digits px-3 pb-1 ms-3 fw-bold">50000 تومان</h6>
                    <div className="d-flex  justify-content-center justify-content-sm-start ms-3 px-3 mb-4">
                      <span style={{ cursor: "pointer" }}>
                        <FaHeart className="color-red"></FaHeart>
                      </span>
                      <span style={{ cursor: "pointer" }} className="mx-3">
                        <FaShoppingCart className="color-red" />
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
